import { useQuery } from "@tanstack/react-query";
import { Badge, Card } from "../components/ui";
import { DataTable } from "../components/DataTable";
import { env } from "../lib/env";
import { supabase } from "../lib/supabase";

interface TenantRow {
  id: string;
  slug: string;
  display_name?: string;
  status: string;
  plan_code: string | null;
  release_channel: string;
  provisioned_at: string | null;
}

export function PlatformTenantsPage() {
  const query = useQuery({
    queryKey: ["platform-tenants"],
    queryFn: async (): Promise<TenantRow[]> => {
      if (env.useMocks) {
        return [
          {
            id: "tenant-luto",
            slug: "luto-cruzeiro",
            display_name: "Cruzeiro Life",
            status: "ACTIVE",
            plan_code: "BUSINESS_VERTICAL",
            release_channel: "demonstração",
            provisioned_at: new Date("2026-09-21T12:00:00-03:00").toISOString(),
          },
          {
            id: "tenant-celomar",
            slug: "celomar",
            display_name: "Yatta Flow",
            status: "ACTIVE",
            plan_code: "ASSETS_VERTICAL",
            release_channel: "demonstração",
            provisioned_at: new Date("2026-09-21T12:05:00-03:00").toISOString(),
          },
        ];
      }
      const { data, error } = await supabase
        .from("platform_tenants")
        .select("id, slug, status, plan_code, release_channel, provisioned_at")
        .order("slug");
      if (error) throw error;
      return data ?? [];
    },
  });

  return (
    <Card
      title="Clientes da plataforma"
      description="Produtos e tenants provisionados na plataforma Yatta Tecnologia."
    >
      <DataTable
        rows={query.data ?? []}
        getKey={(tenant) => tenant.id}
        columns={[
          {
            key: "product",
            header: "Produto",
            render: (tenant) => tenant.display_name ?? tenant.slug,
          },
          { key: "slug", header: "Tenant técnico", render: (tenant) => tenant.slug },
          { key: "plan", header: "Plano", render: (tenant) => tenant.plan_code ?? "—" },
          { key: "channel", header: "Canal", render: (tenant) => tenant.release_channel },
          {
            key: "status",
            header: "Status",
            render: (tenant) => (
              <Badge tone={tenant.status === "ACTIVE" ? "success" : "warning"}>
                {tenant.status}
              </Badge>
            ),
          },
          {
            key: "provisioned",
            header: "Provisionado",
            render: (tenant) =>
              tenant.provisioned_at ? new Date(tenant.provisioned_at).toLocaleString("pt-BR") : "—",
          },
        ]}
      />
    </Card>
  );
}
